"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExpandedNodesListByPath = exports.addPathRecursive = exports.isDescendantPath = exports.getChildTreeNodeIdsFromPath = exports.getParentTreeNodeIdsFromPath = exports.getTreeNodeIdsFromPath = exports.buildTreeNodePath = exports.getTreeNodePaths = exports.buildFilterToExcludeValues = exports.buildFilterToExcludeAttributes = exports.buildFilterToIncludeFilterItemsWithExcludedValues = exports.buildFilterToIncludeFilterItems = void 0;
const store_1 = require("../../../store");
const buildFilterToIncludeFilterItems = (filterItems) => {
    const validators = Object.keys(filterItems).map((attributeId) => ({
        some: Object.assign({ label: {
                equals: attributeId,
            } }, (filterItems[attributeId].length > 0 && {
            allowedValues: {
                some: {
                    value: {
                        in: filterItems[attributeId],
                    },
                },
            },
        })),
    }));
    return {
        validators,
        terminalNodesOnly: true,
    };
};
exports.buildFilterToIncludeFilterItems = buildFilterToIncludeFilterItems;
const buildFilterToIncludeFilterItemsWithExcludedValues = (includedFilterItems, excludedFilterItems) => {
    const attributeIds = Array.from(new Set([
        ...Object.keys(includedFilterItems),
        ...Object.keys(excludedFilterItems),
    ]));
    const validators = attributeIds.map((attributeId) => {
        var _a, _b;
        const includedValues = (_a = includedFilterItems[attributeId]) !== null && _a !== void 0 ? _a : [];
        const excludedValues = (_b = excludedFilterItems[attributeId]) !== null && _b !== void 0 ? _b : [];
        return Object.assign({ some: Object.assign({ label: {
                    equals: attributeId,
                } }, (includedValues.length > 0 && {
                allowedValues: {
                    some: {
                        value: {
                            in: includedValues,
                        },
                    },
                },
            })) }, (excludedValues.length > 0 && {
            none: {
                allowedValues: {
                    some: {
                        value: {
                            in: excludedValues,
                        },
                    },
                },
            },
        }));
    });
    return {
        validators,
        terminalNodesOnly: true,
    };
};
exports.buildFilterToIncludeFilterItemsWithExcludedValues = buildFilterToIncludeFilterItemsWithExcludedValues;
// TODO: implement hasSome filter (the same as for values)
const buildFilterToExcludeAttributes = (filterItems) => {
    const validators = Object.keys(filterItems).map((attributeId) => ({
        none: {
            label: {
                equals: attributeId,
            },
        },
    }));
    return {
        validators,
        terminalNodesOnly: true,
    };
};
exports.buildFilterToExcludeAttributes = buildFilterToExcludeAttributes;
// find tree nodes with the specified attribute that do not contain the selected values
const buildFilterToExcludeValues = (filterItems) => {
    const validators = Object.keys(filterItems).map((attributeId) => ({
        some: {
            label: {
                equals: attributeId,
            },
        },
        none: {
            allowedValues: {
                some: {
                    value: {
                        in: filterItems[attributeId],
                    },
                },
            },
        },
    }));
    return {
        validators,
        terminalNodesOnly: true,
    };
};
exports.buildFilterToExcludeValues = buildFilterToExcludeValues;
// Returns the paths of the tree nodes, concatenating ancestor IDs with the separator
// This is useful for displaying the full path of each node
const getTreeNodePaths = (productTreeNodes) => productTreeNodes === null || productTreeNodes === void 0 ? void 0 : productTreeNodes.map(({ ancestors }) => {
    const pathIds = ancestors.edges.map(({ node }) => node.ancestor.id);
    return pathIds.join(store_1.STRATEGY_NODE_PATH_SEPARATOR);
});
exports.getTreeNodePaths = getTreeNodePaths;
// Build node path from targetNodeId and ancestorIds
const buildTreeNodePath = (ids) => ids.join(store_1.STRATEGY_NODE_PATH_SEPARATOR);
exports.buildTreeNodePath = buildTreeNodePath;
const getTreeNodeIdsFromPath = (path) => (path ? path.split(store_1.STRATEGY_NODE_PATH_SEPARATOR) : []);
exports.getTreeNodeIdsFromPath = getTreeNodeIdsFromPath;
// Returns the parent tree node IDs from the path, excluding the last node (the current node)
const getParentTreeNodeIdsFromPath = (path) => (path ? path.split(store_1.STRATEGY_NODE_PATH_SEPARATOR).slice(0, -1) : []);
exports.getParentTreeNodeIdsFromPath = getParentTreeNodeIdsFromPath;
// Returns the child tree node IDs from the path, excluding the first node (the root)
const getChildTreeNodeIdsFromPath = (path) => (path ? path.split(store_1.STRATEGY_NODE_PATH_SEPARATOR).slice(1) : []);
exports.getChildTreeNodeIdsFromPath = getChildTreeNodeIdsFromPath;
/**
 * Check if childPath is a descendant of parentPath in the tree hierarchy.
 * A node is considered a descendant if it's located under the parent in the tree structure.
 *
 * @param parentPath - The parent node path (e.g., "root.electronics")
 * @param childPath - The potential child node path (e.g., "root.electronics.phones")
 * @returns true if childPath is the same as or a descendant of parentPath, false otherwise
 *
 * @example
 * isDescendantPath("root.electronics", "root.electronics.phones") // true
 * isDescendantPath("root.electronics", "root.electronics") // true (same node)
 * isDescendantPath("root.electronics", "root.clothing") // false
 */
const isDescendantPath = (parentPath, childPath) => {
    if (!parentPath || !childPath)
        return false;
    if (parentPath === childPath)
        return true; // Same node
    // Check if childPath starts with parentPath followed by separator
    // This ensures we match "root.electronics.phones" but not "root.electron"
    return childPath.startsWith(parentPath + store_1.STRATEGY_NODE_PATH_SEPARATOR);
};
exports.isDescendantPath = isDescendantPath;
// Adds a path to the set of unique paths, including all parent paths
const addPathRecursive = (path, uniquePaths) => {
    const pathParts = path.split(store_1.STRATEGY_NODE_PATH_SEPARATOR);
    // only the root node is left
    if (pathParts.length === 1) {
        return;
    }
    if (uniquePaths.has(path)) {
        return;
    }
    uniquePaths.add(path);
    pathParts.pop();
    const newPath = pathParts.join(store_1.STRATEGY_NODE_PATH_SEPARATOR);
    (0, exports.addPathRecursive)(newPath, uniquePaths);
};
exports.addPathRecursive = addPathRecursive;
// Returns the expanded nodes list by the given node path
const getExpandedNodesListByPath = (nodePath) => {
    const newExpandedNodes = new Set();
    (0, exports.addPathRecursive)(nodePath, newExpandedNodes);
    return Array.from(newExpandedNodes);
};
exports.getExpandedNodesListByPath = getExpandedNodesListByPath;
